import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { API_URL } from '../../Config/index';
import swal from 'sweetalert';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { useRef } from 'react';

const LikeButton = ({ nft }) => {
  const { library, account } = useWeb3React();
  const [isLikedIcon, setIsLikedIcon] = useState("");
  const [isAlreadyLiked, setIsAlreadyLiked] = useState("");
  const [isLiked, setIsLiked] = useState(false);
  const [userLiked, setUserLiked] = useState([]);
  const [likedCount, setLikeCount] = useState(nft.NFT_like);
  const ref = useRef(null);


  const handleLike = async () => {
    if (library) {
      if (isLiked) {
        let data = new FormData();
        data.append("action", "like");
        data.append("NFT_id", nft.NFT_id);
        data.append("address", account);
        await axios
          .post(`${API_URL}/likeAPI.php`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            setIsLiked(false);
            setLikeCount(Number(likedCount) - 1);

          })
          .catch(console.log);


      } else {
        let data = new FormData();
        data.append("action", "like");
        data.append("NFT_id", nft.NFT_id);
        data.append("address", account);
        await axios
          .post(`${API_URL}/likeAPI.php`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            setIsLiked(true);
            setLikeCount(Number(likedCount) + 1);
          })
          .catch(console.log);

      }

    } else {
      swal("warning", "Please connect your wallet to perform this action", "warning");
    }
  }

  const handleAlreadyLiked = async (event) => {
    if (library) {
      if (event.currentTarget.classList.contains('text-danger')) {
        let data = new FormData();
        data.append("action", "like");
        data.append("NFT_id", nft.NFT_id);
        data.append("address", account);
        await axios
          .post(`${API_URL}/likeAPI.php`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            setIsAlreadyLiked(false);
            setLikeCount(Number(likedCount) - 1);
          })
          .catch(console.log);

      } else {
        let data = new FormData();
        data.append("action", "like");
        data.append("NFT_id", nft.NFT_id);
        data.append("address", account);
        await axios
          .post(`${API_URL}/likeAPI.php`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            setIsAlreadyLiked(true);
            setLikeCount(Number(likedCount) + 1);
          })
          .catch(console.log);
      }
      getLikesByAddress();

    } else {
      swal("warning", "Please connect your wallet to perform this action", "warning");
    }
  }

  // get the user liked NFTs
  const getLikesByAddress = async () => {
    if (library) {
      let data = new FormData();
      data.append("action", "getLikesByAddress");
      data.append("address", account);
      await axios
        .post(`${API_URL}/likeAPI.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          setUserLiked(res.data);
        })
        .catch(console.log);
    }
  }

  useEffect(() => {

    getLikesByAddress();
  }, [library, isLiked, isAlreadyLiked, account])
  return (
    <div className="nft__item_like" style={{ color: '#000 !important' }}>
      {library && userLiked ? userLiked.filter(entry => entry.tokenId === nft.NFT_id).length > 0 ? <Favorite ref={ref} className="text-danger" style={{ color: 'red' }} onClick={handleAlreadyLiked} /> : <FavoriteBorder ref={ref} className="danger" style={{ color: '#000' }} onClick={handleAlreadyLiked} /> : <FavoriteBorder ref={ref} className="danger" style={{ color: '#000', }} onClick={handleLike} />} {likedCount}
      {/* <span>{likedCount}</span> */}
    </div>
  )
}

export default LikeButton